import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight, Heart, Mail, MessageCircle, Phone, ShieldCheck, UserRound } from "lucide-react";
import { IMAGES, mailLink, telLink, waLink } from "@/config";

const footLinks = [
  { to: "/", label: "Home" },
  { to: "/about/", label: "About" },
  { to: "/vehicles/", label: "Vehicles" },
  { to: "/contact/", label: "Contact" },
];

export const Footer: React.FC = () => (
  <footer className="site-footer">
    <div className="container-x">
      <div className="footer-panel">
        <div className="footer-intro">
          <p className="footer-eyebrow">Driven by people</p>
          <Link to="/" className="footer-brand">
            <img src={IMAGES.brandLogo} alt="" width="58" height="58" />
            <span className="footer-brand-name">Simphiwe <b>Fudwana</b></span>
          </Link>
          <p className="footer-role">Pre-Owned Vehicle Sales Consultant<br />Toyota Tokai</p>
          <p className="footer-description">Helping you find the right vehicle with personal guidance, honest advice, and a smoother buying experience.</p>
          <div className="footer-values">
            <span><UserRound aria-hidden="true" />Personal<br />Guidance</span>
            <span><ShieldCheck aria-hidden="true" />Honest<br />Advice</span>
            <span><Heart aria-hidden="true" />A Smoother<br />Buying Experience</span>
          </div>
          <p className="footer-eyebrow footer-signoff">More than just a car sale</p>
        </div>
        <nav className="footer-links" aria-label="Footer navigation">
          <h2>Quick Links</h2>
          {footLinks.map(({ to, label }) => <Link key={to} to={to} data-testid={`footer-${label.toLowerCase()}`}>{label}<ChevronRight aria-hidden="true" /></Link>)}
        </nav>
        <div className="footer-contact">
          <h2>Let’s Talk</h2>
          <Link to="/contact/" className="footer-contact-button">Get In Touch <ArrowRight aria-hidden="true" /></Link>
          {[
            { label: "Call", detail: "Quick, direct support", href: telLink, Icon: Phone },
            { label: "WhatsApp", detail: "Fast, easy messaging", href: waLink(), Icon: MessageCircle },
            { label: "Email", detail: "Send your enquiry anytime", href: mailLink(), Icon: Mail },
          ].map(({ label, detail, href, Icon }) => (
            <a key={label} href={href} className="footer-contact-card">
              <span className="footer-contact-icon"><Icon aria-hidden="true" /></span>
              <span><strong>{label}</strong><small>{detail}</small></span>
              <ChevronRight aria-hidden="true" />
            </a>
          ))}
        </div>
        <div className="footer-art" aria-hidden="true">
          <p>Good People,<br />Great Journeys<span /></p>
          <img src="/images/dealership-reference.png" alt="" loading="lazy" />
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-toyota">TOYOTA<small>LEAD THE WAY</small></div>
        <Link to="/privacy/">Privacy Policy</Link>
        <Link to="/contact/">Enquiries Welcome</Link>
        <p>© {new Date().getFullYear()} Simphiwe Fudwana. All rights reserved.</p>
        <div className="footer-affiliation"><UserRound aria-hidden="true" /><span>Toyota Tokai Affiliation<small>Personal website of Simphiwe Fudwana</small></span></div>
      </div>
    </div>
  </footer>
);

export default Footer;
